<template>
  <transition name="flash-transit">
    <div class="flashWrapper-js" v-if="visible" @click="toggle">
      <i class="fas fa-bell iconFlash"></i>
      <span>{{status}}</span>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      status: String
    },
    data() {
      return {
        visible: false
      }
    },
    methods: {
      toggle: function() {
        this.visible = !this.visible
      }
    },
    mounted: function() {
      this.visible = true
      window.setTimeout(() => {
        this.visible = false
      }, 2900)
    }
  }
</script>

<style>
  .flashWrapper-js {
    position: fixed;
    width: 40vh;
    height: 10vh;
    bottom: 50px;
    right: 50px;
    z-index: 3;
    background: #4A74C7;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 0 20px;
    justify-content: center;
    font-size: 0.9rem;
    font-weight: 700;
    color: #fff;
    cursor: pointer;
  }

  .iconFlash {
    margin-right: 10px;
  }

  .flash-transit-enter-active, .flash-transit-leave-active {
    transition: opacity .5s, transform .8s;
  }

  .flash-transit-enter, .flash-transit-leave-active {
    opacity: 0;
    transform: translateY(20px);
  }

</style>
